import { useCallback, useContext } from 'react'
import { Table } from './Table'
import api from '../../api'
import { ProjectContext } from '../../contexts'
import { Folder } from '../../types'
import Modal, { ModalProps } from '../../ui/Modal'
import { useTranslation } from 'react-i18next'
import { FolderIcon } from '../../ui/icons'
import { useSearchTableState } from './SearchUtils'

type FolderSelectModalProps = {
    onSelect?: (folder: Folder) => void
    type: Folder['type']
} & Omit<ModalProps, 'title'>

export const FolderSelectModal = ({ open, onClose, onSelect, type }: FolderSelectModalProps) => {
    const { t } = useTranslation()
    const [project] = useContext(ProjectContext)
    const state = useSearchTableState(useCallback(async params => await api.folders.search(project.id, params), [project.id]),
        {
            filter: { type },
        })
    return (
        <Modal
            open={open}
            onClose={onClose}
            title={t('folder_select')}
        >
            <Table
                {...state}
                onSelectRow={item => onSelect?.(item)}
                enableSearch
                columns={[
                    {
                        key: 'name',
                        title: t('title'),
                        cell: ({ item }) => (
                            <div className="multi-cell">
                                <div className="placeholder">
                                    <FolderIcon />
                                </div>
                                <div className="text">
                                    <div className="title">{item.name}</div>
                                    <div className="subtitle">{item.path?.map(item => item.name).join(' -> ')}</div>
                                </div>
                            </div>
                        ),
                    },
                ]}
            />
        </Modal>
    )
}
